import { render } from "./JuryLogin.vue?vue&type=template&id=70010b2a&scoped=true"
import script from "./JuryLogin.vue?vue&type=script&lang=js"
export * from "./JuryLogin.vue?vue&type=script&lang=js"

import "./JuryLogin.vue?vue&type=style&index=0&id=70010b2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70010b2a"]])

export default __exports__